import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule } from '@angular/router';
import { PartnerUserResolver } from '@principle-theorem/ng-principle/pages';
import { APP_ROUTES } from './app.routes';
import { PartnerAppResolver } from './partner-app-resolver.service';
import { PartnerResolver } from './partner-resolver.service';

@NgModule({
  imports: [
    RouterModule.forRoot(APP_ROUTES, {
      useHash: false,
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      paramsInheritanceStrategy: 'always',
      preloadingStrategy: PreloadAllModules,
      bindToComponentInputs: true,
    }),
  ],
  exports: [RouterModule],
  providers: [PartnerResolver, PartnerAppResolver, PartnerUserResolver],
})
export class AppRoutingModule {}
